exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status-nf[data-v-22f4f30c] {\n  align-items: center;\n  display: flex;\n  line-height: normal;\n}\n.status-nf .s-nf-plus-reason[data-v-22f4f30c] {\n  white-space: nowrap;\n}\n", ""]);

// exports
